import styled from 'styled-components';
import {Card} from 'antd';
import {COLORS} from "theme/constants";

export const Wrapper = styled.div`
    background-color: ${COLORS.colorBgLayout};
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const ContentWrapper = styled.div`
    background-color: ${COLORS.colorBgLayout};
    width: 100%;
    max-width: 400px;
    padding: 20px;
`;

export const FormWrapper = styled(Card)`
    max-width: 390px;
    display: block;
    margin: auto;
    margin-top: 25px;
`;

export const FromTitle = styled.div`
    margin-bottom: 70px;
    font-size: 1.7em;
    font-weight: 700;
    text-align: center;
`;
export const Logo = styled.img`
    width: 200px;
    margin-left: auto;
    //margin-top: 26px;
    margin-right: auto;
    display: block;
`;

export const Footer = styled.div`
    color: ${COLORS.colorTextSecondary};
    font-size: 0.8em;
    text-align: center;
    margin-top: 24px;
`;
